import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import CommunityOptOutComponent from './CommunityOptOutComponent';

import { onModalClose } from '../../Modal/actions';
import { communityOptInOut } from '../actions';

import * as commonSelectors from '../../Shared/selectors';

const CommunityOptOutContainer = (props) => {
  const { currentUser, communityOptInOut } = props;
  const currentUserCommunities = currentUser?.communities;

  const onOptInOut = (communityId, isOptIn) => {
    communityOptInOut(communityId, isOptIn);
  };

  return (
    <CommunityOptOutComponent
      currentUserCommunities={currentUserCommunities}
      onOptInOut={onOptInOut}
    />
  );
};

CommunityOptOutContainer.propTypes = {
  currentUser: PropTypes.instanceOf(Object).isRequired,
  communityOptInOut: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  currentUser: commonSelectors.getCurrentUser(state),
});

const mapDispatchToProps = (dispatch) => ({
  onModalClose: () => onModalClose(dispatch),
  communityOptInOut: (communityId, isOptIn) =>
    communityOptInOut(dispatch, communityId, isOptIn),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CommunityOptOutContainer);
